import { Component, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxDataGridModule,
    DxFormComponent,
    DxFormModule,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { Month, ConversionRateGridViewDto, AuthService, PermissionType, AccessType } from '@services';
import EnumUtils from '../../../shared/enum-utils';
import { FilterPanelComponent } from '../../../components/library/filter-panel/filter-panel.component';
import { CapitalCasePipe } from '../../../pipes/capital-case.pipe';
import { FilterConfig, GridPageComponent} from '../../common/grid-page.component';
import { DATE_TIME_FORMAT } from 'src/app/shared/constants';

@Component({
    selector: 'app-conversion-rates',
    imports: [
        CommonModule,
        CapitalCasePipe,
        DxDataGridComponent,
        DxiColumnComponent,
        DxoHeaderFilterComponent,
        DxoScrollingComponent,
        DxButtonComponent,
        DxTemplateDirective,
        DxiItemComponent,
        DxDataGridModule,
        DxoColumnChooserComponent,
        DxoExportComponent,
        DxoLoadPanelComponent,
        DxoSortingComponent,
        DxoToolbarComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoFilterRowComponent,
        DxFormComponent,
        FilterPanelComponent,
        DxoPositionComponent,
        DxoSearchComponent,
        DxoSelectionComponent,
        DxFormModule,
    ],
    templateUrl: './conversion-rates.component.html',
})
export class ConversionRatesComponent extends GridPageComponent<ConversionRateGridViewDto> {
    @ViewChild(DxDataGridComponent, { static: false }) grid!: DxDataGridComponent;
    private authService = inject(AuthService);

    protected override exportName: string = 'Conversion Rate Report';
    protected offset: number = 100;
    public dateTimeFormat = DATE_TIME_FORMAT;
    public minYear = new Date().getFullYear();
    public maxYear = this.minYear + 20;

    dataSource = this.dataSources.conversionRates();
    monthOptions = EnumUtils.getEnumOptions(Month);

    protected override filterConfig: FilterConfig[] = [
        { field: 'rate', op: '>=' },
        { field: 'month', op: '=' },
        { field: 'year', op: '>=' },
    ];

    constructor() {
        super();
        this.init(ConversionRateGridViewDto);
    }

    addNew() {
        this.grid.instance.addRow();
    }

    onRowUpdating(e: any) {
        e.newData = Object.assign({}, e.oldData, e.newData);
    }

    onRowDblClick(e: any) {
        if (e.rowType === 'data' && this.canManage) {
            e.component.editRow(e.rowIndex);
        }
    }

    get canManage() {
        return this.authService.checkPermission(PermissionType.ConversionRates, AccessType.Manage);
    }
}

